module.exports = __webpack_public_path__ + "assets/19b553a50d418f770650ab80c01ebb0c.mp3";